export default "__VITE_ASSET__BXTBq$pp__"